module.exports = __webpack_public_path__ + "static/media/offer.3babd79f.svg";